module.exports = __webpack_public_path__ + "static/media/ai_edit.5b281943.svg";